import { ThemeType } from '../types.js';
const name = 'lions';
const displayName = 'Lions';
const type = ThemeType.Club;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61586107954371',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/lions/logo.svg',
    logoLight: '/assets/images/lions/logo.svg',
    logoMobile: '/assets/images/lions/logo-sm.png',
    logoCard: '/assets/images/lions/logo.svg',
    banner: '/assets/images/lions/banner.png',
    logoBanner: '/assets/images/lions/logo-sm.png',
    favicon: '/assets/images/lions/logo-sm.png',
    partners: [
        '/assets/images/partners/rangers/umbro.png',
        '/assets/images/partners/rangers/32-red.png',
        '/assets/images/partners/rangers/kelloggs.png',
        '/assets/images/partners/rangers/unibet.png',
        '/assets/images/partners/rangers/seko.png',
    ],
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#000061',
                'primary-light': '#E0EBFF',
                'primary-lighter': '#E0EBFF',
                secondary: '#000F2C',
                'secondary-dark': '#000F2C',
                'secondary-light': '#000F2C',
                tertiary: '#B88A44',
                'tertiary-light': '#FAF398',
                'tertiary-dark': '#B88A44',
                black: '#1E293B',
                'black-light': '#566989',
                teal: '#000F2C',
                'pastel-blue': '#000F2C',
            },
        },
    },
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
};
